/**
 * Tipos para la cookie __session consolidada
 */

import {
  PersonalInformation,
  BillingInformation,
  LatLng,
  UserDataWithClaims,
} from '@pedix-workspace/utils';

export interface EndOrderCookieData {
  personalInformation: PersonalInformation;
  billingInformation?: BillingInformation;
}

export interface PublicSessionData {
  app: SessionAppData;
  user?: UserDataWithClaims | null;
}
export type SelectedSubsidiary = string | { id: string; isUserSelected: boolean };
export interface SessionAppData {
  language?: string;
  selectedSubsidiaryMap?: Record<string, SelectedSubsidiary>;
  lastOrderCoordinates?: LatLng;
  endOrderData?: EndOrderCookieData;
}

/**
 * Updates aceptados por `updateAppData`: claves directas de `SessionAppData` y/o rutas con dot
 * notation (ej. `'selectedSubsidiaryMap.mitienda'`), que el merge del handler resuelve con lodash `set`.
 */
export type SessionAppDataUpdates = Partial<SessionAppData> &
  Partial<Record<`selectedSubsidiaryMap.${string}`, SelectedSubsidiary>>;


export interface SessionCookie {
  auth?: string; // JWT de Firebase
  app?: SessionAppData;
}

export type SetCookieParams = {
  origin: string;
  environment?: string;
  maxAge?: number;
};

// Types from express CookieOptions
export interface CookieOptions {
  maxAge?: number | undefined;
  signed?: boolean | undefined;
  expires?: Date | undefined;
  httpOnly?: boolean | undefined;
  path?: string | undefined;
  domain?: string | undefined;
  secure?: boolean | undefined;
  encode?: ((val: string) => string) | undefined;
  sameSite?: boolean | 'lax' | 'strict' | 'none' | undefined;
}

/**
 * Formato legacy: JWT directo (string)
 */
export type LegacySessionCookie = string;
